export default __webpack_public_path__ + "static/media/bike-3.bea5c6fb.svg";